/**
 * Night count between two LocalDateTime strings (date portion only).
 */
import { calendarDateMs } from '../calendarDate';
import { parseDateValue } from '../formatDateWithLocale';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function nightsBetween(
  start: string | undefined,
  end: string | undefined
): number {
  if (!start || !end) {
    return 0;
  }

  const startDate = parseDateValue(start);
  const endDate = parseDateValue(end);
  if (!startDate || !endDate) {
    return 0;
  }

  const diff = calendarDateMs(endDate) - calendarDateMs(startDate);
  if (diff <= 0) {
    return 0;
  }

  return Math.floor(diff / MS_PER_DAY);
}
